import { Link } from 'react-scroll';
import { useState } from 'react';
import '../styling/NavBar.css';

function NavBar({ links }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="menu-container">
      <div className="menu-toggle" onClick={toggleMenu}>
        <span className={`menu-text ${isOpen ? 'open' : ''}`}>{isOpen ? '✕' : '☰'}</span>
        <span>Ahmad TECH</span>
      </div>

      <div className={`sidebar ${isOpen ? 'active' : ''}`} id="sidebar">
        <ul>
          {links.map((link, index) => {
            const hasChildren = Array.isArray(link.children) && link.children.length > 0;

            const renderLink = () => {
              if (link.type === 'scroll') {
                return (
                  <Link
                    to={link.to}
                    smooth={window.innerWidth >= 768}
                    duration={1000}
                    onClick={() => setIsOpen(false)}
                  >
                    {link.label}
                  </Link>
                );
              }
              if (link.type === 'anchor') {
                return (
                  <a href={link.href} onClick={() => setIsOpen(false)}>
                    {link.label}
                  </a>
                );
              }
              return null;
            };

            return (
              <li key={index} className={hasChildren ? 'has-children' : ''}>
                {renderLink()}
                {hasChildren && (
                  <ul className="submenu">
                    {link.children.map((child, childIndex) => (
                      <li key={childIndex}>
                        {child.type === 'anchor' ? (
                          <a href={child.href} onClick={() => setIsOpen(false)}>
                            {child.label}
                          </a>
                        ) : (
                          <Link
                            to={child.to}
                            smooth={window.innerWidth >= 768}
                            duration={1000}
                            onClick={() => setIsOpen(false)}
                          >
                            {child.label}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default NavBar;
